export default __webpack_public_path__ + "static/media/little_icon.12745607.svg";